"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _getIcons = require("@jobmatchme/ui/es/utils/getIcons");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Function to load the specified icon.
 * @param icon - The key of the icon to load.
 * @returns Promise resolving to the loaded icon component.
 */
var loadIcon = function loadIcon(icon) {
  var _iconPool$icon;

  return (_iconPool$icon = _getIcons.iconPool[icon]) === null || _iconPool$icon === void 0 ? void 0 : _iconPool$icon.call(_getIcons.iconPool);
};

var MaterialIcon = function MaterialIcon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      style = _ref.style;

  /** State to hold the dynamically loaded icon component */
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      Icon = _useState2[0],
      setIcon = _useState2[1];
  /**
   * useEffect hook to dynamically load the required icon
   * based on the 'icon' prop.
   * It sets the loaded icon into state for rendering.
   */


  (0, _react.useEffect)(function () {
    var isMounted = true;

    if (icon) {
      loadIcon(icon).then(function (loadedIcon) {
        if (isMounted && loadedIcon) {
          setIcon(function () {
            return loadedIcon;
          });
        }
      });
    }

    return function () {
      isMounted = false;
    };
  }, [icon]);
  /** 
   * If the icon isn't loaded yet, return null. 
   * */

  if (!Icon) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: style,
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {})
  });
};

var _default = MaterialIcon;
exports.default = _default;